import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { BaseDialog } from 'components'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'

const ImportFromSegcoopDialog = ({ open, setOpen, refresh }) => {
  const [selectedProject, setSelectedProject] = useState(null)
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const {
    response,
    isLoading: isLoadingList,
    error: listError,
  } = useFetch(service.dponet.governanceProject.segcoopList, {}, [])

  const segcoopProjects = response?.data?.governanceProjects || []

  useEffect(() => {
    if (listError) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          listError?.response?.data?.error,
        ),
        variant: 'warning',
      })
      setOpen(false)
    }
  }, [listError])

  const handleImport = async () => {
    try {
      setLoading(true)
      await service.dponet.governanceProject.importFromSegcoop({
        token: selectedProject.token,
      })
      snackbar.open({
        message:
          'Importação iniciada. O projeto será processado em segundo plano e aparecerá na lista.',
        variant: 'info',
      })
      setOpen(false)
      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error, false),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Importar do Segcoop"
      actionButtonText="Importar"
      actionButton={handleImport}
      disableButton={!selectedProject || loading}
      loading={loading}
      closeButtonText="Cancelar"
      fullWidth
      dialogSize="sm"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            options={segcoopProjects}
            getOptionLabel={(option) =>
              `${option.name} — ${helpers.formatters.date(
                option.startDate,
              )} até ${helpers.formatters.date(option.endDate)}`
            }
            getOptionSelected={(option, value) => option.token === value.token}
            onChange={(_, value) => setSelectedProject(value)}
            loading={isLoadingList}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Selecionar projeto do Segcoop"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoadingList && (
                        <CircularProgress color="inherit" size={16} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        {selectedProject && (
          <>
            <Grid item xs={12}>
              <TextField
                label="Nome"
                value={selectedProject.name || ''}
                fullWidth
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Finalidade"
                value={selectedProject.purpose || ''}
                fullWidth
                variant="outlined"
                disabled
                multiline
                rows={4}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Data de início"
                value={helpers.formatters.date(selectedProject.startDate) || ''}
                fullWidth
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Data de fim"
                value={helpers.formatters.date(selectedProject.endDate) || ''}
                fullWidth
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Template/Origem"
                value={selectedProject.origin || ''}
                fullWidth
                variant="outlined"
                disabled
              />
            </Grid>
          </>
        )}
      </Grid>
    </BaseDialog>
  )
}

ImportFromSegcoopDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
}

export default ImportFromSegcoopDialog
